import { LAB_REPORT } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
// import { useConfiguration } from "../../../useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const useSearchLabPartnerDetailsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const [labPartnerDetails, setLabPartnerDetails] = useState([]);

  const clearSearchResults = () => {
    setLabPartnerDetails([]);
  };

  const execute = useCallback(
    async (key_word: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res = await axios.get(`${LAB_REPORT?.SEARCH_LAB_PARTNER?.baseURL}?key_word=${key_word}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        if (res.data.status === true) {
          setLabPartnerDetails(res.data.data);
        } else {
          setLabPartnerDetails([]);
        }
        return res.data;
      } catch (e: any) {
        captureError(e);
        sendCurl(e.config["curlCommand"]);
        setLabPartnerDetails([]);
      }
    },
    [dispatch],
  );

  return { execute, clearSearchResults, labPartnerDetails };
};
